import { Check } from "lucide-react";
import { useApp } from "@/lib/i18n";
import { DOC_COLORS, DOC_TYPES } from "@/components/meeting/documents/docTypes";

export const DocTypePicker = ({ value, onChange }) => {
  const { L } = useApp();
  return (
    <div className="sm:col-span-2" data-testid="doc-type-picker">
      <p className="text-xs font-semibold text-slate-600">{L("Jenis dokumen yang dijana", "Document to generate")}</p>
      <p className="mb-2 mt-0.5 text-xs text-slate-500">{L("Dokumen ini akan siap sebaik pemprosesan selesai. Jenis lain boleh dijana kemudian.", "This document will be ready when processing finishes. Other types can be generated later.")}</p>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" role="radiogroup">
        {DOC_TYPES.map(([k, Icon, title, desc]) => {
          const on = value === k;
          const [idle, sel, ic, badge] = DOC_COLORS[k];
          return (
            <button key={k} type="button" role="radio" aria-checked={on} onClick={() => onChange(k)} data-testid={`upload-doc-type-${k}`}
              className={`relative rounded-2xl border p-4 text-left transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 ${on ? sel : idle}`}>
              {on && <span className={`absolute right-3 top-3 grid h-5 w-5 place-items-center rounded-full text-white ${badge}`}><Check size={12} /></span>}
              <Icon size={20} className={ic} />
              <p className="mt-2 font-heading text-sm font-bold text-slate-900">{L(...title)}</p>
              <p className="mt-1 text-xs leading-snug text-slate-500">{L(...desc)}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};
